import { ArticleCategoryList } from "./components/ArticleCategoryList/ArticleCategoryList";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { WellKnownLearningMaterialCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { WellbeingResourceTiles } from "./components/WellbeingResourceTiles/WellbeingResourceTiles";
import { WellbeingToolTiles } from "./components/WellbeingToolTiles/WellbeingToolTiles";
import { useTranslation } from "react-i18next";
import { ResourceViewer } from "./components/ResourceViewer/ResourceViewer";
import { Column, Row } from "shared/UI/LayoutComponents/LayoutComponents";

export const ViewResource = () => <ResourceViewer pageTitle="pageTitle.resources.article" />;

export const Resources = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t("pageTitle.resources.home")} />
      <Row>
        <Column>
          <div className="space-y-4">
            <div>
              <h2>{t("resources.heading")}</h2>
              <p>{t("resources.headingParagraph")}</p>
            </div>
            <WellbeingToolTiles />
          </div>
          <div className="space-y-4">
            <div>
              <h2>{t("resources.subHeading")}</h2>
              <p>{t("resources.subHeadingParagraph")}</p>
            </div>
            <WellbeingResourceTiles />
          </div>
          <ArticleCategoryList
            heading={t("resources.audioAndVideoArticlesHeading")}
            description={t("resources.audioAndVideoArticlesDescription")}
            category={WellKnownLearningMaterialCategories.audioAndVideo}
            ariaLabel={t("resources.audioAndVideoArticlesLabel")}
          />
          <ArticleCategoryList
            heading={t("resources.podcastsArticlesHeading")}
            description={t("resources.podcastsArticlesDescription")}
            category={WellKnownLearningMaterialCategories.podcasts}
            ariaLabel={t("resources.podcastsArticlesLabel")}
          />
        </Column>
        <Column>
          <ArticleCategoryList
            heading={t("resources.articleLibraryHeading")}
            description={t("resources.articleLibraryDescription")}
            category={WellKnownLearningMaterialCategories.articles}
            ariaLabel={t("resources.articlesLabel")}
          />
          <ArticleCategoryList
            heading={t("resources.newsletterArticlesHeading")}
            description={t("resources.newsletterArticlesDescription")}
            category={WellKnownLearningMaterialCategories.newsletters}
            ariaLabel={t("resources.newsletterArticlesLabel")}
          />
        </Column>
      </Row>
    </>
  );
};
